var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRequestAccessVisa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 355,
    height: 356,
    viewBox: "0 0 355 356",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1434_4891",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -2,
    y: -1,
    width: 359,
    height: 358
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -1.41016,
    y: 64.0234,
    width: 300,
    height: 300,
    rx: 7.8125,
    transform: "rotate(-12.5 -1.41016 64.0234)",
    fill: "url(#paint0_radial_1434_4891)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1434_4891)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 155.37,
    y: 163.914,
    width: 37.1094,
    height: 37.1094,
    rx: 7.61719,
    transform: "rotate(-12.5 155.37 163.914)",
    stroke: "#B5B5C2",
    strokeWidth: 0.390625
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.006,
    y: 149.648,
    width: 74.6094,
    height: 74.6094,
    rx: 7.61719,
    transform: "rotate(-12.5 133.006 149.648)",
    stroke: "#B5B5C2",
    strokeWidth: 0.390625
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.639,
    y: 135.406,
    width: 112.109,
    height: 112.109,
    rx: 7.61719,
    transform: "rotate(-12.5 110.639 135.406)",
    stroke: "#B5B5C2",
    strokeWidth: 0.390625
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.2798,
    y: 121.156,
    width: 149.609,
    height: 149.609,
    rx: 7.61719,
    transform: "rotate(-12.5 88.2798 121.156)",
    stroke: "#B5B5C2",
    strokeWidth: 0.390625
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.9126,
    y: 106.914,
    width: 187.109,
    height: 187.109,
    rx: 7.61719,
    transform: "rotate(-12.5 65.9126 106.914)",
    stroke: "#B5B5C2",
    strokeWidth: 0.390625
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.5533,
    y: 92.6718,
    width: 224.609,
    height: 224.609,
    rx: 7.61719,
    transform: "rotate(-12.5 43.5533 92.6718)",
    stroke: "#B5B5C2",
    strokeWidth: 0.390625
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.1861,
    y: 78.4218,
    width: 262.109,
    height: 262.109,
    rx: 7.61719,
    transform: "rotate(-12.5 21.1861 78.4218)",
    stroke: "#B5B5C2",
    strokeWidth: 0.390625
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1.1772,
    y: 64.1718,
    width: 299.609,
    height: 299.609,
    rx: 7.61719,
    transform: "rotate(-12.5 -1.1772 64.1718)",
    stroke: "#B5B5C2",
    strokeWidth: 0.390625
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1434_4891)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 154,
    width: 48,
    height: 48,
    rx: 9.30247,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.465,
    y: 154.465,
    width: 47.0698,
    height: 47.0698,
    rx: 8.83735,
    stroke: "#EAECF0",
    strokeWidth: 0.930247,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198 150C197.072 150 196.182 150.369 195.525 151.025C194.869 151.682 194.5 152.572 194.5 153.5V155.5C193.97 155.5 193.461 155.711 193.086 156.086C192.711 156.461 192.5 156.97 192.5 157.5V162C192.5 162.53 192.711 163.039 193.086 163.414C193.461 163.789 193.97 164 194.5 164H201.5C202.03 164 202.539 163.789 202.914 163.414C203.289 163.039 203.5 162.53 203.5 162V157.5C203.5 156.97 203.289 156.461 202.914 156.086C202.539 155.711 202.03 155.5 201.5 155.5V153.5C201.5 151.567 199.933 150 198 150ZM200.5 155.5V153.5C200.5 152.837 200.237 152.201 199.768 151.732C199.299 151.263 198.663 151 198 151C197.337 151 196.701 151.263 196.232 151.732C195.763 152.201 195.5 152.837 195.5 153.5V155.5H200.5Z",
    fill: "#C13434"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1434_4891)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.408 187.296C169.935 187.296 169.533 187.13 169.201 186.798C168.869 186.466 168.703 186.064 168.703 185.591V175.344C168.703 174.872 168.869 174.469 169.201 174.137C169.533 173.805 169.936 173.639 170.41 173.639H175.655V170.087C175.655 169.705 175.792 169.377 176.066 169.101C176.34 168.825 176.67 168.688 177.055 168.688H178.954C179.336 168.688 179.664 168.825 179.939 169.101C180.215 169.377 180.352 169.705 180.352 170.087V173.639H185.593C186.066 173.639 186.469 173.805 186.801 174.137C187.133 174.469 187.299 174.872 187.299 175.344V185.591C187.299 186.064 187.133 186.466 186.801 186.798C186.469 187.13 186.067 187.296 185.595 187.296H170.408ZM172.256 183.588H177.827V183.333C177.827 183.078 177.759 182.841 177.621 182.624C177.484 182.406 177.291 182.244 177.043 182.137C176.708 181.999 176.376 181.896 176.047 181.828C175.718 181.761 175.382 181.727 175.041 181.727C174.699 181.727 174.36 181.761 174.025 181.83C173.69 181.898 173.355 182.001 173.019 182.137C172.785 182.244 172.599 182.405 172.462 182.62C172.325 182.835 172.256 183.072 172.256 183.333V183.588ZM179.981 182.089H183.92V180.958H179.981V182.089ZM175.037 180.958C175.398 180.958 175.707 180.831 175.963 180.578C176.219 180.325 176.347 180.018 176.347 179.657C176.347 179.295 176.221 178.986 175.968 178.73C175.715 178.474 175.408 178.346 175.046 178.346C174.685 178.346 174.376 178.473 174.12 178.726C173.864 178.979 173.736 179.286 173.736 179.647C173.736 180.009 173.862 180.317 174.115 180.574C174.368 180.83 174.676 180.958 175.037 180.958ZM179.981 179.478H183.92V178.346H179.981V179.478ZM177.054 175.423H178.953V170.087H177.054V175.423Z",
    fill: "#011229"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1434_4891",
    x: 152.14,
    y: 148.07,
    width: 55.721,
    height: 56.721,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.930247
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.930247
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1434_4891"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1434_4891",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1434_4891",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(148.59 214.023) rotate(90) scale(150 150)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1434_4891"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(166 166)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestAccessVisa);
export default __webpack_public_path__ + "static/media/request_access_visa.7c7b7af8cf84b43aac0c52986a5a3567.svg";
export { ForwardRef as ReactComponent };